module.exports = __webpack_public_path__ + "img/login_coverImage.05698822.png";